import type { StateService, UIRouterGlobals } from "@uirouter/angularjs";
import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IAccountRepository } from "App/Modules/Auth";
import type { IResponseWithLoading } from "App/Modules/Models";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

export default class CancelVerificationComponentController {
    public static $inject: string[] = ["$scope", "$uiRouterGlobals", "$state", "mmAccountRepository"];

    public verificationKey: string;

    public cancelVerificationResponse: IResponseWithLoading<void>;

    constructor(
        private readonly $scope: IScope,
        private readonly $uiRouterGlobals: UIRouterGlobals,
        private readonly $state: StateService,
        private readonly accountRepository: IAccountRepository,
    ) {}

    public $onInit() {
        this.verificationKey = this.$uiRouterGlobals.params.verificationKey;
    }

    public cancelVerification() {
        this.cancelVerificationResponse = { isLoading: true };
        extendWithLoadingAndFail(this.accountRepository.cancelVerification(this.verificationKey))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<void>) => {
                    this.cancelVerificationResponse = response;
                    if (!response.isLoading && response.isSuccessful) {
                        setTimeout(() => {
                            this.$state.go("dashboard");
                        }, 3000);
                    }
                },
                (error) => {
                    this.cancelVerificationResponse = error;
                    setTimeout(() => {
                        this.$state.go("dashboard");
                    }, 3000);
                },
            );
    }
}
